var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgInstagram = function SvgInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.607 3.474a2.262 2.262 0 0 0-2.25 2.25v12a2.262 2.262 0 0 0 2.25 2.25h12a2.262 2.262 0 0 0 2.25-2.25v-12a2.262 2.262 0 0 0-2.25-2.25h-12zm9.75 2.25h2.25v2.25h-2.25v-2.25zm-3.75 3c1.666 0 3 1.334 3 3s-1.334 3-3 3-3-1.334-3-3 1.334-3 3-3zm-6.75 1.5h2.508a4.493 4.493 0 0 0-.258 1.5c0 2.476 2.024 4.5 4.5 4.5s4.5-2.024 4.5-4.5c0-.524-.092-1.032-.258-1.5h2.508v7.5c0 .424-.326.75-.75.75h-12a.738.738 0 0 1-.75-.75v-7.5z",
    fill: "currentColor"
  })));
};
export default SvgInstagram;